import storageService from './storage.js';

/**
 * Service class to manage couponse.
 */
export default function couponService() {
  /**
   * Apply the default coupon to the storage service.
   */
  function applyDefaultCoupon() {
    storageService().coupon = {
      coupon_code: '30OffTMUOrder',
      discount_amount: 21,
      name: '30% Off Coupon',
      type: 'Amount',
    };
  }

  return {
    applyDefaultCoupon,
  };
}
